import { Box, Container, useMediaQuery, useTheme } from "@carrotfertility/carotene-core"
import { UserDropdown } from "features/global-ui/user-dropdown"
import React from "react"

export const MainLayout = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const theme = useTheme()
  const showUserDropdown = useMediaQuery(theme.breakpoints.up("md"))
  return (
    <Box
      display="flex"
      height="100%"
      flexDirection="row"
      justifyContent="center"
      paddingX="medium"
      paddingTop={{ xs: "38px", md: "64px" }}
    >
      <Container
        disableGutters
        sx={(theme) => ({
          paddingX: theme.spacing(theme.tokens.spacing.lg)
        })}
      >
        {showUserDropdown ? (
          <Box textAlign="right">
            <UserDropdown />
          </Box>
        ) : null}
        {children}
      </Container>
    </Box>
  )
}
